import { Table } from "react-bootstrap";

import { PropertyRent } from "../../utils/interface";
import DeleteButton from "../DeleteButton";

interface ListPropertyRentsProps {
  propertyRents: PropertyRent[];
  onDeletePropertyRent: (propertyRentId: number) => void;
}

const ListPropertyRents: React.FC<ListPropertyRentsProps> = ({
  propertyRents,
  onDeletePropertyRent,
}) => {
  return (<>
    <Table striped hover size="sm">
      <thead>
        <tr>
          <th>Rent#</th>
          <th>Rental Type</th>
          <th>Amount</th>
          <th>Currency</th>
          <th>From</th>
          <th>To</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {propertyRents.map((rent: PropertyRent) => (
          <tr key={rent.propertyRentId}>
            <td>{rent.propertyRentId}</td>
            <td>{rent.rentalTypeEnumDescription}</td>
            <td>{rent.rentAmount}</td>
            <td>{rent.currency}</td>
            <td>{rent.fromDate}</td>
            <td>{rent.thruDate}</td>
            <td>
              <DeleteButton
                onClick={() => onDeletePropertyRent(rent.propertyRentId)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  </>);
};

export default ListPropertyRents;
